function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.14 137.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.57,137.14a68.57,68.57,0,1,1,68.57-68.57A68.65,68.65,0,0,1,68.57,137.14Zm0-128A59.43,59.43,0,1,0,128,68.57,59.5,59.5,0,0,0,68.57,9.14Z",
    style: {
      fill: "#f32735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31,51.59h2.52a4.84,4.84,0,0,1,4.83,4.52L78,106.77a4.83,4.83,0,0,1-4.83,5.15H64a4.84,4.84,0,0,1-4.83-5.15l3.31-50.66A4.84,4.84,0,0,1,67.31,51.59ZM61.94,28a9,9,0,0,1,6.57-2.75A9.39,9.39,0,0,1,78,34.66a9.39,9.39,0,0,1-9.44,9.44,9,9,0,0,1-6.57-2.75,9.51,9.51,0,0,1,0-13.38Z",
    style: {
      fill: "#f32735"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationDanger);
export default __webpack_public_path__ + "static/media/exclamation_danger.96098dd9d239e0701003f25ea8d0fa30.svg";
export { ForwardRef as ReactComponent };